import { render, staticRenderFns } from "./IconJzgztw.vue?vue&type=template&id=0f1cf298"
import script from "./IconJzgztw.vue?vue&type=script&lang=js"
export * from "./IconJzgztw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports